import React from 'react'
import './index.less'
import Overlay from './../../share/Overlay/index'

class ActivityRuleDialog extends React.Component {
    render () {
        const { activityRuleContent = '', handleShowRule, ruleContentTitle } = this.props
        return (
            <React.Fragment>
                <Overlay />
                <div className={'activityRule'}>
                    <p>
                        <span>{ ruleContentTitle}</span>
                        <i className={'closeIcon'} onClick={() => handleShowRule()}/>
                    </p>
                    <div className={'ruleContainer'} dangerouslySetInnerHTML={{ __html: activityRuleContent }} />

                </div>
            </React.Fragment>
        )
    }
}

export default ActivityRuleDialog
